import { render, staticRenderFns } from "./detalheLead.vue?vue&type=template&id=17130b21&"
import script from "./detalheLead.vue?vue&type=script&lang=js&"
export * from "./detalheLead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports